/** Real pages from Volume 3, "Expression in Motion", shown in the Look Inside carousel. */
export type LookInsideSlide = {
  src: string
  caption: string
  width: number
  height: number
}

export const lookInsideSlides: LookInsideSlide[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/5mYqFHXVfucmM39wRW4BfQ/slide-1.png',
    caption: 'The cover: 9 sessions, 30/45/60-minute versions, seated and wheelchair options',
    width: 820,
    height: 1456,
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/5Ui7w8u5GRSk68KfshcrLx/slide-2.png',
    caption: 'The Movement Quality Palette: the framework behind every session',
    width: 820,
    height: 1456,
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rvvMh7hGWXCv2i33Mn6Cam/slide-3.png',
    caption: 'Room diagrams you can set up in minutes',
    width: 820,
    height: 1456,
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vwqhDpB2wKfBoHgehKWkT7/slide-4.png',
    caption: 'Session cards with props, opening words and an Energy Dial',
    width: 820,
    height: 1456,
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/f1LvgTn2fTswYuknfLFeCz/slide-5.png',
    caption: "Why 'show me in a shape' works when 'how do you feel?' doesn't",
    width: 820,
    height: 1456,
  },
]
